import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../App';

// Renders rotating ads for a given slot key. Falls back to a "Your Ad Here" placeholder.
const AdSlot = ({ slot, fallback = true, style = {} }) => {
  const [ads, setAds] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    axios.get(`${API}/advertisements/active?slot=${slot}`)
      .then((r) => setAds(r.data.ads || []))
      .catch(() => {});
  }, [slot]);

  // Rotate every 8s if multiple ads
  useEffect(() => {
    if (ads.length <= 1) return undefined;
    const t = setInterval(() => setIdx((i) => (i + 1) % ads.length), 8000);
    return () => clearInterval(t);
  }, [ads]);

  // Fire impression when ad is shown
  useEffect(() => {
    if (!ads[idx]) return;
    axios.post(`${API}/advertisements/${ads[idx].id}/track?event=impression`).catch(() => {});
  }, [ads, idx]);

  if (ads.length === 0) {
    if (!fallback) return null;
    return (
      <div data-testid={`ad-slot-${slot}-placeholder`} style={{
        background: 'linear-gradient(135deg, #F8FAFC 0%, #F1F5F9 100%)',
        border: '1.5px dashed #CBD5E1',
        borderRadius: 12,
        padding: '1.25rem',
        textAlign: 'center',
        color: '#94A3B8',
        ...style,
      }}>
        <div style={{ fontSize: '0.7rem', textTransform: 'uppercase', fontWeight: 700, letterSpacing: '0.08em', marginBottom: 4 }}>Advertisement</div>
        <div style={{ fontSize: '0.85rem', color: '#475569', fontWeight: 600, marginBottom: 6 }}>Your Ad Here</div>
        <a href="/advertise" style={{ fontSize: '0.78rem', color: '#FF6B35', fontWeight: 700, textDecoration: 'none' }} data-testid={`ad-slot-${slot}-cta`}>Reach 10K+ users → Advertise</a>
      </div>
    );
  }

  const ad = ads[idx];
  const handleClick = () => {
    axios.post(`${API}/advertisements/${ad.id}/track?event=click`).catch(() => {});
  };

  return (
    <a
      href={ad.cta_url}
      target="_blank"
      rel="noopener noreferrer sponsored"
      onClick={handleClick}
      data-testid={`ad-slot-${slot}-ad`}
      style={{
        display: 'block',
        background: ad.bg_color || 'white',
        border: '1px solid #E2E8F0',
        borderRadius: 12,
        padding: '1.1rem 1.25rem',
        textDecoration: 'none',
        color: '#0F172A',
        position: 'relative',
        overflow: 'hidden',
        ...style,
      }}
    >
      <span style={{ position: 'absolute', top: 6, right: 8, fontSize: '0.6rem', color: '#94A3B8', textTransform: 'uppercase', letterSpacing: '0.06em', fontWeight: 700 }}>Ad</span>
      {ad.image_url && (
        <img src={ad.image_url} alt="" style={{ width: '100%', height: 'auto', borderRadius: 8, marginBottom: 10 }} />
      )}
      <div style={{ fontSize: '1rem', fontWeight: 800, marginBottom: 4 }}>{ad.headline}</div>
      {ad.body && <div style={{ fontSize: '0.825rem', color: '#475569', marginBottom: 10 }}>{ad.body}</div>}
      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 5, background: '#FF6B35', color: 'white', padding: '5px 12px', borderRadius: 999, fontSize: '0.78rem', fontWeight: 700 }}>
        {ad.cta_text} →
      </div>
    </a>
  );
};

export default AdSlot;
